import { useNewOrder } from "@/queries/order/useNewOrder";
import { useCreateNewOrder } from "@/queries/order/useCreateNewOrder";
import { useSetOrderUuid } from "@/stores/orderIdStore";
import { useEffect } from "react";

interface UseOrderOrCreateOptions {
  orderUuid?: string;
  panels?: number;
  enabled?: boolean;
}

export function useOrderOrCreate({
  orderUuid,
  panels = 0,
  enabled = true,
}: UseOrderOrCreateOptions = {}) {
  const setOrderUuid = useSetOrderUuid();

  const {
    data: order,
    isLoading: isLoadingNewOrder,
    isError,
  } = useNewOrder({
    uuid: orderUuid,
  });

  const {
    mutate: createNewOrder,
    isPending: isCreating,
    isError: isCreatingError,
  } = useCreateNewOrder({
    mutationConfig: {
      onSuccess: (data) => {
        if (data.uuid) {
          setOrderUuid(data.uuid);
        }
      },
    },
  });

  useEffect(() => {
    if (!orderUuid) {
      createNewOrder(panels);
    }
  }, [orderUuid]);

  return {
    order,
    isLoading: isLoadingNewOrder || isCreating,
    isError: isError || isCreatingError,
    createOrder: (panelCount?: number) => createNewOrder(panelCount ?? panels),
  };
}
